export const ABILITIES = {
    clawSwipe: {
        id: "clawSwipe",
        name: "Claw Swipe",
        hotkey: "1",
        range: 3.5,
        energyCost: 10,
        cooldownMs: 1200,
        effect: "damage",
        magnitude: 8,
        requiresTarget: true,
        targetingArcDegrees: 60,
        leapDistance: 0,
    },
    pawLeap: {
        id: "pawLeap",
        name: "Paw Leap",
        hotkey: "2",
        range: 12,
        energyCost: 25,
        cooldownMs: 6000,
        effect: "leap",
        magnitude: 14,
        requiresTarget: true,
        targetingArcDegrees: 40,
        leapDistance: 9,
    },
    magicalPurr: {
        id: "magicalPurr",
        name: "Magical Purr",
        hotkey: "3",
        range: 0,
        energyCost: 30,
        cooldownMs: 8000,
        effect: "heal",
        magnitude: 35,
        requiresTarget: false,
        targetingArcDegrees: 0,
        leapDistance: 0,
    },
};
export const ABILITY_BY_HOTKEY = Object.fromEntries(Object.values(ABILITIES).map((ability) => [ability.hotkey, ability]));
//# sourceMappingURL=abilities.js.map